var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdfOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 21C4.45 21 3.979 20.8043 3.587 20.413C3.19567 20.021 3 19.55 3 19V5C3 4.45 3.19567 3.979 3.587 3.587C3.979 3.19567 4.45 3 5 3H19C19.55 3 20.021 3.19567 20.413 3.587C20.8043 3.979 21 4.45 21 5V19C21 19.55 20.8043 20.021 20.413 20.413C20.021 20.8043 19.55 21 19 21H5ZM5 19H19V5H5V19Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.88462 11.5754C9.88462 12.2777 9.31769 12.8446 8.61538 12.8446H7.76923V13.9023C7.76923 14.2493 7.48154 14.5369 7.13462 14.5369C6.78769 14.5369 6.5 14.2493 6.5 13.9023V10.3062C6.5 9.84079 6.88077 9.46002 7.34615 9.46002H8.61538C9.31769 9.46002 9.88462 10.0269 9.88462 10.7293V11.5754ZM14.1154 13.2677C14.1154 13.97 13.5485 14.5369 12.8462 14.5369H11.1538C10.9169 14.5369 10.7308 14.3508 10.7308 14.1139V9.8831C10.7308 9.64618 10.9169 9.46002 11.1538 9.46002H12.8462C13.5485 9.46002 14.1154 10.0269 14.1154 10.7293V13.2677ZM17.5 10.0946C17.5 10.4416 17.2123 10.7293 16.8654 10.7293H16.2308V11.5754H16.8654C17.2123 11.5754 17.5 11.8631 17.5 12.21C17.5 12.5569 17.2123 12.8446 16.8654 12.8446H16.2308V13.9023C16.2308 14.2493 15.9431 14.5369 15.5962 14.5369C15.2492 14.5369 14.9615 14.2493 14.9615 13.9023V10.3062C14.9615 9.84079 15.3423 9.46002 15.8077 9.46002H16.8654C17.2123 9.46002 17.5 9.74771 17.5 10.0946ZM7.76924 11.5754H8.61539V10.7292H7.76924V11.5754ZM12 13.2677H12.8462V10.7292H12V13.2677Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfOutline);
export default __webpack_public_path__ + "static/media/PDF_Outline.4ffbfce402871d6b0cf93908e3d74b8d.svg";
export { ForwardRef as ReactComponent };